import { render } from "./TuesdayActionFlag.vue?vue&type=template&id=1f59a9c7&scoped=true"
const script = {}

import "./TuesdayActionFlag.vue?vue&type=style&index=0&id=1f59a9c7&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f59a9c7"]])

export default __exports__